import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { SessionPage } from '@/pages/session/SessionPage'
import { JoinPage } from '@/pages/join'
import { ErrorBoundary } from '@/components/ErrorBoundary'

// Lazy-load admin pages — keeps them out of the participant-facing bundle
const AdminLayout = lazy(() => import('@/pages/admin/AdminLayout').then(m => ({ default: m.AdminLayout })))
const Dashboard = lazy(() => import('@/pages/admin/Dashboard').then(m => ({ default: m.Dashboard })))
const ImageLibrary = lazy(() => import('@/pages/admin/ImageLibrary').then(m => ({ default: m.ImageLibrary })))
const ImageUpload = lazy(() => import('@/pages/admin/ImageUpload').then(m => ({ default: m.ImageUpload })))
const ProjectList = lazy(() => import('@/pages/admin/ProjectList').then(m => ({ default: m.ProjectList })))
const ProjectDetail = lazy(() => import('@/pages/admin/ProjectDetail').then(m => ({ default: m.ProjectDetail })))
const ProjectForm = lazy(() => import('@/pages/admin/ProjectForm').then(m => ({ default: m.ProjectForm })))
const EventDetail = lazy(() => import('@/pages/admin/EventDetail').then(m => ({ default: m.EventDetail })))
const EventForm = lazy(() => import('@/pages/admin/EventForm').then(m => ({ default: m.EventForm })))
const AdminSessionDetail = lazy(() => import('@/pages/admin/AdminSessionDetail').then(m => ({ default: m.AdminSessionDetail })))
const EventList = lazy(() => import('@/pages/admin/EventList').then(m => ({ default: m.EventList })))
const Gallery = lazy(() => import('@/pages/admin/Gallery').then(m => ({ default: m.Gallery })))

function AdminFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <p className="font-body text-muted animate-pulse">Loading admin...</p>
    </div>
  )
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          {/* Public session routes */}
          <Route path="/" element={<SessionPage />} />
          <Route path="/session" element={<SessionPage />} />
          <Route path="/session/:facilitatorId" element={<SessionPage />} />

          {/* Join session by code */}
          <Route path="/join" element={<JoinPage />} />
          <Route path="/join/:code" element={<JoinPage />} />

          {/* Admin routes — lazy-loaded */}
          <Route path="/admin" element={<Suspense fallback={<AdminFallback />}><AdminLayout><Dashboard /></AdminLayout></Suspense>} />
          <Route path="/admin/events" element={<Suspense fallback={<AdminFallback />}><AdminLayout><EventList /></AdminLayout></Suspense>} />
          <Route path="/admin/gallery" element={<Suspense fallback={<AdminFallback />}><AdminLayout><Gallery /></AdminLayout></Suspense>} />
          <Route path="/admin/projects" element={<Suspense fallback={<AdminFallback />}><AdminLayout><ProjectList /></AdminLayout></Suspense>} />
          <Route path="/admin/projects/new" element={<Suspense fallback={<AdminFallback />}><AdminLayout><ProjectForm /></AdminLayout></Suspense>} />
          <Route path="/admin/projects/:id" element={<Suspense fallback={<AdminFallback />}><AdminLayout><ProjectDetail /></AdminLayout></Suspense>} />
          <Route path="/admin/projects/:id/events/new" element={<Suspense fallback={<AdminFallback />}><AdminLayout><EventForm /></AdminLayout></Suspense>} />
          <Route path="/admin/projects/:pid/events/:eventId" element={<Suspense fallback={<AdminFallback />}><AdminLayout><EventDetail /></AdminLayout></Suspense>} />
          <Route path="/admin/projects/:pid/events/:eventId/sessions/:sid" element={<Suspense fallback={<AdminFallback />}><AdminLayout><AdminSessionDetail /></AdminLayout></Suspense>} />
          <Route path="/admin/images" element={<Suspense fallback={<AdminFallback />}><AdminLayout><ImageLibrary /></AdminLayout></Suspense>} />
          <Route path="/admin/images/upload" element={<Suspense fallback={<AdminFallback />}><AdminLayout><ImageUpload /></AdminLayout></Suspense>} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
